// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__larsseitFonts_be09a1', '__larsseitFonts_Fallback_be09a1'"},"className":"__className_be09a1"};